import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, hidePreloader, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {getRentalCarPrices, gTagClickEventValue} from "./frontend_script";
import {DateComponent, TimeComponent} from "./DateComponent";
import {getCurrentMinDate, getDisabledHours,getDefaultStartTime, getDefaultEndTime, getDefaultEndDate} from "./Utils";
import moment from "moment/moment";

class SearchFormLocalPage extends Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onChangeLocation = this.onChangeLocation.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.getSearchAjax = this.getSearchAjax.bind(this);
		this.onChangeVehicleGroup = this.onChangeVehicleGroup.bind(this);

		const book_data = this.props.booking_form_data.booking?this.props.booking_form_data.booking : {};

		let formats_date = ["DD-MM-YYYY", "DD/MM/YYYY", "DD/MMM/YYYY"];
		let formats_time = ["hh:mm A"];

		let _fromDate = book_data.pickup_date &&  moment(book_data.pickup_date, formats_date, true).isValid() ? moment(book_data.pickup_date, formats_date) : null,
			_fromTime =  book_data.pickup_time &&  moment(book_data.pickup_time, formats_time, true).isValid() ? moment(book_data.pickup_time, formats_time) : null,
			_toDate = book_data.return_date &&  moment(book_data.return_date, formats_date, true).isValid() ? moment(book_data.return_date, formats_date) : null,
			_toTime = book_data.return_time &&  moment(book_data.return_time, formats_time, true).isValid() ? moment(book_data.return_time, formats_time) : null;

		this.state = {
			/*dates and times*/
			fromDate: _fromDate, // if not null then is moment instance
			toDate: _toDate,   // if not null then is moment instance
			fromTime: _fromTime, //from that we will need only times, if not null, then is moment instance
			toTime: _toTime, // from that we will need only times, if not null, then is moment instance

			/*other*/
			location_group: this.props.booking_form_data.location_group !== undefined ? this.props.booking_form_data.location_group : '',
			pickup_location: this.props.booking_form_data.booking.pickuplocationid !== undefined ? this.props.booking_form_data.booking.pickuplocationid : '',
			selected_location_group: this.props.booking_form_data.location_group !== undefined ? true : false,
			search_result_show: false,
			pickuplocationid: '',
			dropofflocationid: '',
			campaigncode: this.props.booking_form_data.booking.campaigncode !== undefined ? this.props.booking_form_data.booking.campaigncode : "",
			category_group_filter: this.props.category_group_filter,
			search_result: {
				'success': 0,
				'vehicles': {},
				'vehicles_closest': {},
				'vehicles_closest_date': {},
				'error_limit': 0
			},
			search_result_filter: {
				'vehicles': {},
				'vehicles_closest': {},
				'vehicles_closest_date': {},
			},
			booking_form_data: this.props.booking_form_data,
			to_show: {
				kms: ""
			},
			location_groupError: this.props.booking_form_data.location_group === undefined ? 'This field is required.' : '',
			location_groupDirty: false,
			pickup_locationError: this.props.booking_form_data.booking.pickuplocationid === undefined ? 'This field is required.' : '',
			pickup_locationDirty: false,
			pickup_dateError: _fromDate?'':'This field is required.',
			pickup_dateDirty: _fromDate?true:false,
			pickup_timeError: _fromTime?'':'This field is required.',
			pickup_timeDirty: _fromTime?true:false,
			return_dateError: _toDate?'':'This field is required.',
			return_dateDirty: _toDate?true:false,
			return_timeError: _toTime?'':'This field is required.',
			return_timeDirty: _toTime?true:false,
			validate: false,
			showWarning:false
		};
	}

	componentDidMount() {
		if (this.props.mini_form_data === true && window.has_only_location == false) {
			if (this.props.booking_form_data.booking !== undefined) {
				let book_data = this.props.booking_form_data.booking;
				let set_to_state = {};

				let formats_date = ["DD-MM-YYYY", "DD/MM/YYYY", "DD/MMM/YYYY"];
				let formats_time = ["hh:mm A"];

				let _fromDate = book_data.pickup_date &&  moment(book_data.pickup_date, formats_date, true).isValid() ? moment(book_data.pickup_date, formats_date) : null,
					_fromTime =  book_data.pickup_time &&  moment(book_data.pickup_time, formats_time, true).isValid() ? moment(book_data.pickup_time, formats_time) : null,
					_toDate = book_data.return_date &&  moment(book_data.return_date, formats_date, true).isValid() ? moment(book_data.return_date, formats_date) : null,
					_toTime = book_data.return_time &&  moment(book_data.return_time, formats_time, true).isValid() ? moment(book_data.return_time, formats_time) : null;

				if (book_data.pickup_date) {
					set_to_state.fromDate = _fromDate;
					set_to_state.pickup_dateError = '';
					set_to_state.pickup_dateDirty = true;
				}
				if (book_data.pickup_time) {
					set_to_state.fromTime = _fromTime;
					set_to_state.pickup_timeError = '';
					set_to_state.pickup_timeDirty = true;
				}
				if (book_data.return_date) {
					set_to_state.toDate = _toDate;
					set_to_state.return_dateError = '';
					set_to_state.return_dateDirty = true;
				}
				if (book_data.return_time) {
					set_to_state.toTime = _toTime;
					set_to_state.return_timeError = '';
					set_to_state.return_timeDirty = true;
				}

				if ( !book_data.pickup_location || book_data.pickup_location.length < 2 ) {
					set_to_state.pickup_locationError = 'Please select point you will travel from.';
					set_to_state.return_timeDirty = true;
				}
				// if no error only !
				this.setState(set_to_state, this.getSearchAjax);

			}
		}
		if (this.props.scroll_to_element === 'id_search_form_local_div') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				offset: window.offset_scroll_value(),
//				containerId: "id_scrolling_div"
			});
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
	}

	componentDidUpdate(previousProps) {
		if (this.props.category_group_filter !== previousProps.category_group_filter) {
			this.setState({category_group_filter: this.props.category_group_filter});
		}

		const firstError = document.querySelector('.has-danger');
		if (firstError) {
			const target = firstError.querySelector('input, select, textarea, [tabindex]:not([tabindex="-1"])');
			if (target) {
				scroller.scrollTo(target.id, {
					duration: 800,
					smooth: true,
					offset: window.offset_scroll_value(),
				});
				target.focus({preventScroll: true});
			}
		}
	}

	onChange(e) {

		this.setState({location_group: e.target.value,
			selected_location_group: true,
			pickup_location: '',
			pickup_locationError: 'This field is required.'}
		);

		if (e.target.value && e.target.value.length > 0)
			this.setState({location_groupError: ''});

		this.props.handleSetSearchResult(false, false, {}, {}, 0);
	}

	onChangeLocation(e) {
		let value = e.target.value;
		let booking_data = this.state.booking_form_data;

		booking_data.booking.pickuplocationid = value;
		booking_data.booking.dropofflocationid = value;

		this.setState({pickup_location: value, booking_form_data: booking_data});
		if (value && value.length > 0)
			this.setState({pickup_locationError: ''});
		this.props.handleSetSearchResult(false, false, {}, {}, 0);
	}

	onBlurHandler(e) {
		switch (e.target.name) {
			case 'location_group':
				this.setState({location_groupDirty: true});
				break;
			case 'pickup_location':
				this.setState({pickup_locationDirty: true});
				break;
		}
	}

	setInitialDataBooking() {
		 let booking_form_data = this.state.booking_form_data;
		if (this.state.booking_form_data.booking.vehicle === undefined || this.state.booking_form_data.booking.vehicle.length === 0) {
			if( Object.keys(this.state.search_result.vehicles) && Object.keys(this.state.search_result.vehicles).length) {
				booking_form_data.booking.vehicle = this.state.search_result.vehicles[0].id;
			}
			else if(Object.keys(this.state.search_result.vehicles_closest_date) && Object.keys(this.state.search_result.vehicles_closest_date).length) {
				booking_form_data.booking.vehicle = this.state.search_result.vehicles_closest_date[0].id;
				booking_form_data.booking.alternative_pickupdate = this.state.search_result.vehicles_closest_date[0]._pickupdate;
				booking_form_data.booking.alternative_dropoffdate = this.state.search_result.vehicles_closest_date[0]._dropoffdate;
			}
			else if( Object.keys(this.state.search_result.vehicles_closest) && Object.keys(this.state.search_result.vehicles_closest).length) {
				booking_form_data.booking.vehicle = this.state.search_result.vehicles_closest[0].id;
				booking_form_data.booking.alternative_location = this.state.search_result.vehicles_closest[0].location_id;
			}
			this.setState({booking_form_data: booking_form_data});
		}
	}

	callbackRentalCarPrices(resp, t) {
		let to_show = t.state.to_show;
		let prices = resp.prices;
		to_show.data_original_title = 'All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim. Reducing your excess liability coverage to $1000 for your hire period costs $' + prices.premium_insurance + ' per day.';
		to_show.insurance_cover = prices.premium_insurance;
		to_show.span_roadside_assistance = prices.roadside_assistance_price;
		if (prices.allowance > 0)
			to_show.kms = prices.allowance;
		to_show.span_towing_surcharge = prices.towing_surcharge_price;

		t.setState({to_show: to_show});
		t.props.handleSetShowData(t.state.to_show);
	}

	filterSearchResults(vehicles, vehicles_closest, vehicles_closest_date, t) {
		let vehicles_filtered = [];
		let vehicles_closest_date_filtered = [];
		let vehicles_closest_filtered = [];

		if (t.state.category_group_filter > 0) {
			let bf_category_categories = window.bf_category_categories;
			if (bf_category_categories && Object.keys(bf_category_categories) && Object.keys(bf_category_categories).length > 0 && Object.keys(bf_category_categories[t.state.category_group_filter]) && Object.keys(bf_category_categories[t.state.category_group_filter]).length > 0) {
				if ( vehicles && Object.keys(vehicles) && Object.keys(vehicles).length > 0) {
					let i = 0;
					Object.keys(vehicles).map((k) => {
						if (bf_category_categories[t.state.category_group_filter].includes(vehicles[k].vehiclecategoryid)) {
							vehicles_filtered[i] = vehicles[k];
							i++;
						}
					});
				}
				if ( vehicles_closest_date && Object.keys(vehicles_closest_date) && Object.keys(vehicles_closest_date).length > 0) {
					let i = 0;
					Object.keys(vehicles_closest_date).map((k) => {
						if (bf_category_categories[t.state.category_group_filter].includes(vehicles_closest_date[k].vehiclecategoryid)) {
							vehicles_closest_date_filtered[k] = vehicles_closest_date[k];
							i++;
						}
					});
				}
				if ( vehicles_closest && Object.keys(vehicles_closest) && Object.keys(vehicles_closest).length > 0) {
					let i = 0;
					Object.keys(vehicles_closest).map((k) => {
						if (bf_category_categories[t.state.category_group_filter].includes(vehicles_closest[k].vehiclecategoryid)) {
							vehicles_closest_filtered[k] = vehicles_closest[k];
							i++;
						}
					});
				}
			}
		}
		else if (t.state.category_group_filter === 0) {
			vehicles_filtered = vehicles;
			vehicles_closest_date_filtered = vehicles_closest_date;
			vehicles_closest_filtered = vehicles_closest;
		}

		let search_result_filter = {
			'vehicles': ( vehicles_filtered && Object.keys(vehicles_filtered) && Object.keys(vehicles_filtered).length) ? vehicles_filtered : {},
			'vehicles_closest_date': (vehicles_closest_date_filtered && Object.keys(vehicles_closest_date_filtered) && Object.keys(vehicles_closest_date_filtered).length) ? vehicles_closest_date_filtered : {},
			'vehicles_closest': (vehicles_closest_filtered && Object.keys(vehicles_closest_filtered) && Object.keys(vehicles_closest_filtered).length) ? vehicles_closest_filtered : {}

		}

		t.setState({search_result_filter: search_result_filter});
	}

	getSearchAjax() {

		let validate = true;
		let pickup_date = $('#pickup_date').val();
		if (!pickup_date || pickup_date.length === 0) {
			this.setState({pickup_dateDirty: true, validate: false});
			validate = false;
		}
		else{
			this.setState({pickup_dateDirty: true, pickup_dateError: ''});
		}
		let return_date = $('#return_date').val();
		if (!return_date || return_date.length === 0) {
			this.setState({return_dateDirty: true, validate: false});
			validate = false;
		}
		else {
			this.setState({return_dateDirty: true, return_dateError: ''});
		}
		let pickup_time = $('#pickup_time').val();
		if (!pickup_time || pickup_time.length === 0) {
			this.setState({pickup_timeError: 'This field is required.', pickup_timeDirty: true, validate: false});
			validate = false;
		}
		else {
			this.setState({pickup_timeError: '', pickup_timeDirty: true});
		}

		let return_time = $('#return_time').val();

		if ( !return_time || return_time.length === 0) {
			this.setState({return_timeError: 'This field is required.', return_timeDirty: true, validate: false});
			validate = false;
		}
		else {
			this.setState({return_timeError: '', return_timeDirty: true});
		}

		if ( validate && pickup_date && return_date && pickup_time && return_time &&  pickup_date.length > 0 && return_date.length > 0 && pickup_time.length > 0 && return_time.length > 0) {

			let selected_pickup_time = moment(pickup_date+' '+pickup_time, "DD-MM-YYYY hh:mm A");
			let selected_return_time = moment(return_date+' '+return_time, "DD-MM-YYYY hh:mm A");
			let toSet = {};
			let min_pickup_time = moment(pickup_date, "DD-MM-YYYY").add(7, 'hours').add(59, 'minutes');
			let max_pickup_time = moment(pickup_date, "DD-MM-YYYY").add(17, 'hours').add(31, 'minutes');
			if (selected_pickup_time.isBefore(max_pickup_time) && selected_pickup_time.isAfter(min_pickup_time)) {
				toSet.pickup_timeError = '';
				toSet.pickup_timeDirty = false;
				if (validate)
					toSet.validate = true;
			}
			else {
				toSet.pickup_timeError = 'Vehicle access for starting a hire is limited to between 8am to 5.30pm, to ensure vehicle accessibility at the hiring location. Please adjust your booking times accordingly.';
				toSet.pickup_timeDirty = true;
				toSet.validate = validate = false;
			}

			if (selected_pickup_time.isBefore(moment().add(1, 'hours'))) {
				toSet.pickup_timeError = 'Vehicle access for starting a hire is limited to one hour after the current time, to ensure vehicle accessibility at the hiring location. Please adjust your booking times accordingly.';
				toSet.pickup_timeDirty = true;
				toSet.validate = validate = false;
				toSet.showWarning = false;
			}

			let min_return_time = moment(return_date, "DD-MM-YYYY").add(7, 'hours').add(59, 'minutes');
			let max_return_time = moment(return_date, "DD-MM-YYYY").add(17, 'hours').add(31, 'minutes');
			if (selected_return_time.isBefore(max_return_time) && selected_return_time.isAfter(min_return_time)) {
				toSet.return_timeError = '';
				toSet.return_timeDirty = false;
				if (validate)
					toSet.validate = true;
			}
			else {
				toSet.return_timeError = 'Vehicle access for finishing a hire is limited to between 8am to 5.30pm, to ensure vehicle accessibility at the hiring location. Please adjust your booking times accordingly.';
				toSet.return_timeDirty = true;
				toSet.validate = validate = false;
				toSet.showWarning = false;
			}
			this.setState(toSet, this.validateDateTime);
		}

		if ( !this.state.location_group || this.state.location_group.length === 0) {
			validate = false;
			this.setState({validate:false, location_groupError: 'This field is required.', location_groupDirty: true});
		}

		if ( !this.state.pickup_location || this.state.pickup_location.length === 0) {
			validate = false;
			this.setState({validate:false, pickup_locationError: 'This field is required.', pickup_locationDirty: true});
		}

		if ( validate && this.state.pickup_dateError.length === 0 && this.state.return_dateError.length === 0 && this.state.location_groupError.length === 0 && this.state.pickup_locationError.length === 0 && validate) {
			window.localStorage.setItem('end_create_booking', moment().add(15, 'minutes').format("DD-MM-YYYY hh:mm:ss A") );
			window.localStorage.setItem('start_create_booking', '1');
			if (typeof window.startBooking === 'function')
				window.startBooking();

			try {
				gTagClickEventValue('click_to_search', {'event_category': 'booking', 'event_label': 'booking-search'});
			}
			catch (e) {
			}
			gTagClickEventValue('click', {'event_category': 'booking', 'event_label': 'booking-search'});

			let fields = this.props.booking_field_list.get_local_vehicles;
			//let btn = e.target;
			let form_inputs = $('#id_local_search').closest('.order-data');
			let params = {};
			let booking_data = this.state.booking_form_data;

			let t = this;

			for (let item in fields) {
				let el = form_inputs.find('[name=' + fields[item] + ']');
				if (el && el.length) {
					params[fields[item]] = el[0].value.trim();
					booking_data.booking[fields[item]] = el[0].value.trim();
				}
			}

			this.setState({booking_form_data: booking_data});

			params.action = 'api/booking/get-vehicles';
			params.hire = booking_data.booking.hire;
			params.pickuplocationid = booking_data.booking.pickuplocationid;
			params.dropofflocationid = booking_data.booking.dropofflocationid;

			AJAX(bf_ajax_url, 'POST', params, {
				response_json: true,
				func_waiting: function () {
					showPreloader();
				},
				func_callback: function (resp) {
					if (resp.success === 1) {
						let search_result = t.state.search_result;
						search_result.success = resp.success;
						search_result.error_limit = resp.error_limit;
						if (resp.vehicles !== undefined)
							search_result.vehicles = resp.vehicles;
						else
							search_result.vehicles = {};
						if (resp.variant_closest !== undefined)
							search_result.vehicles_closest = resp.variant_closest;
						else
							search_result.vehicles_closest = {};
						if (resp.variant_closest_date !== undefined)
							search_result.vehicles_closest_date = resp.variant_closest_date;
						else
							search_result.vehicles_closest_date = {};

						t.filterSearchResults(search_result.vehicles, search_result.vehicles_closest, search_result.vehicles_closest_date, t);

						t.setState({search_result_show: true, search_result: search_result});

						t.setInitialDataBooking();

						getRentalCarPrices(t.state.booking_form_data.booking, t.callbackRentalCarPrices, t);

						t.props.handleSetSearchResult(true, false, t.state.search_result, t.state.search_result_filter, t.state.category_group_filter);
						t.props.handleSetBookingFormData(t.state.booking_form_data.booking, {}, {}, {location_group: t.state.location_group});
						t.props.handleResetVehicles();
						t.props.handleSetSomeBlock('scroll_to_element', 'id_vehicles_div');
						hidePreloader();
					}
					else {

						let search_result = t.state.search_result;
						search_result.success = resp.success;
						search_result.error_limit = resp.error_limit;
						search_result.vehicles = {};
						search_result.vehicles_closest = {};
						search_result.vehicles_closest_date = {};
						t.setState({search_result_show: true, search_result: search_result});
						t.setInitialDataBooking();
						t.props.handleSetSearchResult(true, false, t.state.search_result, t.state.search_result_filter, t.state.category_group_filter);
						t.props.handleSetBookingFormData(t.state.booking_form_data.booking, {}, {}, {location_group: t.state.location_group});
						t.props.handleResetVehicles();
						t.props.handleSetSomeBlock('scroll_to_element', 'id_vehicles_div');

						hidePreloader();

						if (resp.message) {
							showPopupWithGoBack(resp.message);
						}
						else {
							showPopupWithGoBack('Our system currently isn\'t showing any available vehicles at that location during this time period; please contact Go With The Gecko on <a href="tel:1300 826 883">1300 826 883</a> and we will be able to help identify a quick easy solution to your booking needs.');
						}
						if (typeof window.stopBooking === 'function')
							window.stopBooking();
					}
				},
				func_error: function (resp) {
					hidePreloader();
					showPopupWithGoBack(resp.message);
					if (typeof window.stopBooking === 'function')
						window.stopBooking();
				}
			});

		}
		else {
			if (typeof window.stopBooking === 'function')
				window.stopBooking();
		}
	}

	fromDateChange = (date) => {
		if (date === null) {
			this.setState({fromDate: null});
		}
		else {
			let toSet = {fromDate: date, validate: false};
			if (this.state.toDate === null) {
				toSet.pickup_dateError = '';
				toSet.return_dateError = '';
				toSet.pickup_dateDirty = false;
				toSet.return_dateDirty = false;
			}
			else {
				let date_pickup = new Date(date.format('YYYY-MM-DD')).getTime();
				let date_return = new Date(this.state.toDate.format('YYYY-MM-DD')).getTime();
				if( date_return < date_pickup ) {
					toSet.toDate = null;
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				}
				else {
					if (date_return == date_pickup ) {
						if (this.state.fromTime !== null && this.state.toTime !== null &&  this.state.toTime.hour() <= this.state.fromTime.hour()){
							toSet.return_dateError = 'Date must be after start date';
							toSet.return_dateDirty = true;
						}
					}
					else{
						toSet.pickup_dateError = '';
						toSet.return_dateError = '';
						toSet.pickup_dateDirty = false;
						toSet.return_dateDirty = false;
					}
				}
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResult(false, false, {}, {}, 0);
	}
	toDateChange = (date) => {
		if (date === null) {
			this.setState({toDate: null});
		}
		else {
			let toSet = {toDate: date, validate: false};
			if(this.state.fromDate !== null) {
				let date_pickup = new Date(this.state.fromDate.format('YYYY-MM-DD')).getTime();
				let date_return = new Date(date.format('YYYY-MM-DD')).getTime();
				if (date_return < date_pickup) {
					toSet.toDate = null;
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				}
				else {
					if (date_return == date_pickup ) {
						if (this.state.fromTime !== null && this.state.toTime !== null &&  this.state.toTime.hour() <= this.state.fromTime.hour()){
							toSet.return_dateError = 'Date must be after start date';
							toSet.return_dateDirty = true;
						}
					}
					else{
						toSet.pickup_dateError = '';
						toSet.return_dateError = '';
						toSet.pickup_dateDirty = false;
						toSet.return_dateDirty = false;
					}
				}
			}
			else {
				toSet.return_dateError = '';
				toSet.return_dateDirty = false;
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResult(false, false, {}, {}, 0);
	}
	fromTimeChange = (date) => {
		if (date === null) {
			this.setState({fromTime: null});
		}
		else {
			let toSet = {fromTime: date, pickup_timeError: '', pickup_timeDirty: false, validate: false};
			const { fromDate, toDate, toTime } = this.state;
			if (fromDate && toDate && toTime) {
				const pickupDateTime = fromDate.clone().set({
					hour: date.hour(),
					minute: date.minute()
				});
				const returnDateTime = toDate.clone().set({
					hour: toTime.hour(),
					minute: toTime.minute()
				});
				if (!returnDateTime.isAfter(pickupDateTime)) {
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				} else {
					toSet.return_dateError = '';
					toSet.return_dateDirty = false;
				}
			}
			else {
				toSet.return_dateError = '';
				toSet.return_dateDirty = false;
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResult(false, false, {}, {}, 0);
	}
	toTimeChange = (date) => {
		if (date === null) {
			this.setState({toTime: null});
		}
		else {
			let toSet = {toTime: date, return_timeError: '', return_timeDirty: false, validate: false};
			const {fromDate, toDate, fromTime} = this.state;
			if (fromDate && toDate && fromTime) {
				const pickupDateTime = fromDate.clone().set({
					hour: fromTime.hour(),
					minute: fromTime.minute()
				});
				const returnDateTime = toDate.clone().set({
					hour: date.hour(),
					minute: date.minute()
				});

				if (!returnDateTime.isAfter(pickupDateTime)) {
					toSet.return_dateError = 'Date must be after start date';
					toSet.return_dateDirty = true;
				} else {
					toSet.return_dateError = '';
					toSet.return_dateDirty = false;
				}
			} else {
				toSet.return_dateError = '';
				toSet.return_dateDirty = false;
			}
			this.setState(toSet, this.validateDateTime);
		}
		this.props.handleSetSearchResult(false, false, {}, {}, 0);
	}

	getDefaultStartTime = () => getDefaultStartTime(this.state.fromDate);
	getDefaultEndDate =  () =>  getDefaultEndDate(this.state.fromDate, 'local');
	getDefaultEndTime =  () =>  getDefaultEndTime(this.state.fromTime, this.state.fromDate);
	getDisabledHours =  () => getDisabledHours(this.state.fromDate, this.state.fromTime,false);
	getDisabledHoursReturn =  () => getDisabledHours(this.state.fromDate, this.state.fromTime,true, this.state.toDate);

	validateDateTime = () => {
		let { fromDate, toDate, fromTime, toTime } = this.state;
		if (!fromDate || !toDate || !fromTime || !toTime) return;

		let startDateTime = fromTime ? fromDate.clone().set({ hour: fromTime.hour(), minute: fromTime.minute() }) : fromDate.clone().set({ hour: 0, minute: 0 });

		let mindate = moment().add(50, 'minutes');

		if (!startDateTime.isAfter(mindate)) {
			this.setState({
				pickup_dateError: 'Start date and time must be at least one hour ahead of the current time.',
				pickup_dateDirty: true
			});
		}
		else {
			this.setState({
				pickup_dateError: '',
				pickup_dateDirty: false
			});
		}

		let endDateTime = toTime ? toDate.clone().set({ hour: toTime.hour(), minute: toTime.minute() }) : toDate.clone().set({ hour: 0, minute: 0 });

		if (!endDateTime.isAfter(startDateTime)) {
			this.setState({
				return_dateError: 'End date and time must be after start date and time',
				return_dateDirty: true
			});
		}
		else {
			this.setState({
				return_dateError: '',
				return_dateDirty: false
			});
		}
		this.checkDuration();
	};
	checkDuration() {
		if (
			this.state.toDate &&
			this.state.fromDate &&
			this.state.toTime &&
			this.state.fromTime
			&&
			!this.state.return_timeError
			&&
			!this.state.pickup_timeError
			&&
			!this.state.return_dateError
			&&
			!this.state.pickup_dateError

		) {

			let p_date = (this.state.fromDate).format('DD-MM-YYYY');
			let r_date = (this.state.toDate).format('DD-MM-YYYY');
			let p_time = (this.state.fromTime).format('hh:mm A');
			let r_time = (this.state.toTime).format('hh:mm A');

			let start = moment(p_date + ' ' + p_time, 'DD-MM-YYYY hh:mm A');
			let end = moment(r_date + ' ' + r_time, 'DD-MM-YYYY hh:mm A');

			let duration_days = moment.duration(end.diff(start)).days();
			let duration_hours = moment.duration(end.diff(start)).hours();
			let duration_minutes = moment.duration(end.diff(start)).minutes() + duration_hours * 60;

			let one_day = 24*60;

			if ( duration_days >= 1 && ( (duration_minutes > one_day && (duration_minutes % one_day) < 240 ) || ( duration_minutes > 0 && duration_minutes < 240 )) ) {
				this.setState({showWarning:true});
				this.props.showWarning(true);
			}
			else {
				this.setState({showWarning:false});
				this.props.showWarning(false);
			}
		}
	}
	onChangeVehicleGroup(e) {
		this.setState({category_group_filter: parseInt(e.target.value)});
		this.props.handleSetSearchResult(false, false, {}, {}, parseInt(e.target.value));
	}

	render() {
		let location_group = window.bf_locations;
		let category_groups = window.bf_category_groups;

		return (<>
			<RedirectOnlyHome />

			<div id={'id_search_form_local_div'} className={'order-data'}>
				<div className="row">
					<div className="col-md-12">
						<div className="row locations">
							<div className={'col-md-6'}>
								<label className={'required'}>Select Region</label>
								<div className={'form-group '+((this.state.location_groupDirty && this.state.location_groupError) && 'has-danger')}>
									<i className="icon-location2"></i>
									<select className="form-control"
											id="location_group"
											name="location_group"
											onChange={this.onChange}
											onBlur={this.onBlurHandler}
											value={this.state.location_group}>
										<option value="" disabled={true}>Select Region</option>
										{Object.keys(location_group).map((keyName) => (
											<option value={keyName} key={keyName}>{keyName}</option>
										))}
									</select>
									{
										(this.state.location_groupDirty && this.state.location_groupError) &&
										<small className="form-control-feedback d-block">{this.state.location_groupError}</small>
									}
								</div>
							</div>
							<div className={'col-md-6'}>
								<label className={'required'}>Select Location</label>
								<div className={'form-group '+((this.state.pickup_locationDirty && this.state.pickup_locationError) && 'has-danger')}>
									<i className="icon-location2"></i>
									<select className="form-control required"
											name="pickup_location"
											id="pickup_location"
											disabled={!this.state.selected_location_group}
											onChange={this.onChangeLocation}
											onBlur={this.onBlurHandler}
											value={this.state.pickup_location}>
										<option value="" disabled={true}>Pickup location</option>
										{this.state.location_group &&
											(
												location_group[this.state.location_group].map((keyName) => (
													<option value={keyName.value} key={keyName.value}>{keyName.text}</option>))
											)
										}
									</select>
									{
										(this.state.pickup_locationDirty && this.state.pickup_locationError) &&
										<small className="form-control-feedback d-block">{this.state.pickup_locationError}</small>
									}
								</div>
							</div>
						</div>
						<div className="row">
							<div className={'col-md-3'}>
								<div className={'form-group '+((this.state.pickup_dateDirty && this.state.pickup_dateError) && 'has-danger')}>
								<DateComponent
									minDate={getCurrentMinDate()}
									name={"pickup_date"}
									placeholder={"Pickup date"}
									key={'from_local'}
									defaultDate={getCurrentMinDate()}
									setDate={this.state.fromDate}
									onChange={this.fromDateChange}
									value={this.props.booking_form_data.booking.pickup_date}
								/>
								{
									(this.state.pickup_dateDirty && this.state.pickup_dateError) &&
									<small className="form-control-feedback d-block">{this.state.pickup_dateError}</small>
								}
							</div>
							</div>
							<div className={'col-md-3'}>
								<div className={'form-group '+((this.state.pickup_timeDirty && this.state.pickup_timeError) && 'has-danger')}>
								<TimeComponent
									key={`${this.state.fromDate}`}
									setTime={this.state.fromTime}
									defaultDate={this.getDefaultStartTime()}
									disabledHours={this.getDisabledHours()}
									name={"pickup_time"}
									placeholder={"Pickup time"}
									onChange={this.fromTimeChange}
									value={this.props.booking_form_data.booking.pickup_time}
								/>
								{
									(this.state.pickup_timeDirty && this.state.pickup_timeError) &&
									<small className="form-control-feedback d-block">{this.state.pickup_timeError}</small>
								}
							</div>
							</div>
							<div className={'col-md-3'}>
								<div className={'form-group '+((this.state.return_dateDirty && this.state.return_dateError) && 'has-danger')}>
								<DateComponent
									minDate={ this.state.fromDate ? this.state.fromDate.clone().subtract(1, 'day') : null }
									name={"return_date"}
									placeholder={"Return date"}
									key={'to_local'}
									defaultDate={this.getDefaultEndDate()}
									setDate={this.state.toDate}
									onChange={this.toDateChange}
									value={this.props.booking_form_data.booking.return_date}
								/>
								{
									(this.state.return_dateDirty && this.state.return_dateError) &&
									<small className="form-control-feedback d-block">{this.state.return_dateError}</small>
								}
							</div>
							</div>
							<div className={'col-md-3'}>
								<div className={'form-group '+((this.state.return_timeDirty && this.state.return_timeError) && 'has-danger')}>
								<TimeComponent
									key={`${this.state.fromDate}-${this.state.fromTime}`}
									setTime={this.state.toTime}
									defaultDate={ this.getDefaultEndTime() }
									disabledHours={ this.getDisabledHoursReturn() }
									name={"return_time"}
									placeholder={"Return time"}
									onChange={this.toTimeChange}
									value={this.props.booking_form_data.booking.return_time}
								/>
								{
									(this.state.return_timeDirty && this.state.return_timeError) &&
									<small className="form-control-feedback d-block">{this.state.return_timeError}</small>
								}
							</div>
							</div>
						</div>
						<div className="row">
							<div className={'col-md-6'}>
								<label>Promo Code</label>
								<div className="form-group ">
									<i className="icon2-coupon"></i>
									<input
										className="form-control"
										autoComplete="off"
										type="text"
										defaultValue={this.state.campaigncode}
										name="campaigncode"
										placeholder="Promo-Code if any..."
									/>
								</div>
							</div>
							<div className={'col-md-6'}>
								<label>Select Vehicle</label>
								<div className="form-group">
									<i className="icon3-sports-car"></i>
									<select className="form-control"
										name="category_group"
										onChange={this.onChangeVehicleGroup}
										value={this.state.category_group_filter}>
										<option value="0" key="0"></option>
										{Object.keys(category_groups).map((keyName) => (
											<option value={category_groups[keyName]} key={category_groups[keyName]}>{keyName}</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="form-group col-md-12">
								{this.state.showWarning &&  <p style={{color:"#d63545",margin:"0",marginBottom:"5px",fontSize:"14px"}}>Gecko Money Saving Tip: Decreasing your booking length can help you save money on daily charges.</p>}
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<input type="button" value="Search" className="btn btn-red" id="id_local_search" onClick={this.getSearchAjax} />
					</div>
				</div>
			</div>
		</>);
	}
}

export default SearchFormLocalPage;